import React, {memo} from 'react';
import {Document, Font} from '@react-pdf/renderer';
import {IntlShape} from 'react-intl';
import QuoteCoverPage from './QuoteCoverPage';
import QuoteNarrativePage from './QuoteNarrativePage';
import QuoteEstimatePage from './QuoteEstimatePage';
import QuoteTermsPage from './QuoteTermsPage';
import QuoteAgreementPage from './QuoteAgreementPage';
import type {QuoteDocumentData, QuoteTemplate} from '../resolver/types';

type QuotePDFProps = {
	data: QuoteDocumentData;
	template: QuoteTemplate;
	intl: IntlShape;
};

// Done to avoid words being hyphenated in the PDF
Font.registerHyphenationCallback(word => [word]);

/**
 * The client-facing document: Cover · Introduction/Scope · Estimate · Terms · Agreement.
 * The narrative and terms pages are conditionally present; page numbers stay correct because
 * the footer reads the real rendered page count.
 */
const QuotePDF = memo(({data, template, intl}: QuotePDFProps): JSX.Element => {
	const showNarrative = template.showIntroduction || template.showScopeOfWork;
	return (
		<Document>
			<QuoteCoverPage data={data} template={template} intl={intl} />
			{showNarrative && <QuoteNarrativePage data={data} template={template} intl={intl} />}
			<QuoteEstimatePage data={data} template={template} intl={intl} />
			{template.showTerms && <QuoteTermsPage data={data} template={template} intl={intl} />}
			<QuoteAgreementPage data={data} template={template} intl={intl} />
		</Document>
	);
});

export default QuotePDF;
